import { IIntegrationStore } from './index'

export default {
  status: 0,
  checked: false,
  listings: [],
  tab: 0,
  sync: 0,
  priceTab: 0,
  notConnectedModal: false,
  prices: [],
  loadingPrice: false,
  loadingConfiguration: false,
  loadingListings: true,
  configuration: {},
  savingConfiguration: false,
  agreement: false,
  backdrop: false,
  step: 1,
  confirmStep: 1,
} as IIntegrationStore
